import { render, staticRenderFns } from "./compose-ganyu.vue?vue&type=template&id=73f22b2a"
import script from "./compose-ganyu.vue?vue&type=script&lang=ts"
export * from "./compose-ganyu.vue?vue&type=script&lang=ts"
import style0 from "./compose-ganyu.vue?vue&type=style&index=0&id=73f22b2a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports